import { Perfil } from "../Perfil/perfil.entity";

export class FiltroUsuarios {
  public identificacion: string;
  public nombres: string;
  public apellidos: string;
  public desde: Date;
  public hasta: Date;
  public empresa: string;
  public activo: boolean;
  public perfil: Perfil;
  public rol: string;
  public userCode: string;
}

export class FiltroUsuariosApp {
  public identificacion: string;
  public userCode: string;
}
